import { useContext, useState } from "react";
import PropTypes from "prop-types";
import validator from "validator";
import ResultsWrappers from "../modals/ResultsWrapper";
import SubmitApplicationLetter from "../modals/SubmitApplicationLetter";
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import NextRouter from "next/router";
import moment from "moment";
import {
  OrganizationSticker,
  PremiumTeamSticker,
} from "../../styles/globalSVG";
import { GlobalContext } from "components/context/GlobalContext";
import { useAuth } from "components/context/auth";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 207,
    height: 240,
    backgroundColor: "#ffffff",
    boxShadow: "none",
    border: "1px solid rgba(0, 27, 17, 0.1)",
    borderRadius: 12,
  },
  avatarDiv: {
    display: "contents",
  },
  avatar: {
    backgroundColor: "#F8C22B",
    height: 80,
    width: 80,
    marginBottom: 10,
  },
  cardMargin: {
    marginBottom: theme.spacing(0.5),
  },
  cardHeader: {
    textAlign: "center",
    padding: "5px",
  },
  cardTitle: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 20,
    textAlign: "center",
    letterSpacing: 0.15,
  },
  cardSubtitle: {
    fontFamily: "Open Sans",
    fontWeight: 400,
    fontSize: 12,
    letterSpacing: 0.15,
  },
  cardCat: {
    fontFamily: "Open Sans",
    fontWeight: 700,
    fontSize: 13,
    color: "#001B11",
  },
  cardText: {
    color: "rgba(0, 27, 17, 0.7)",
    fontFamily: "Open Sans",
    margin: theme.spacing(1),
    fontSize: 13,
    fontWeight: 600,
  },
  cardFooter: {
    color: "rgba(0, 27, 17, 0.6)",
    fontFamily: "Open Sans",
    fontSize: 13,
    fontWeight: 400,
    display: "flex",
    flexDirection: "column",
  },
  created: {
    fontStyle: "italic",
    paddingBottom: 5,
    fontSize: 13,
  },
  numberTeamMates: {
    paddingBottom: 5,
    fontSize: 13,
  },
}));
const TeamCardItem = ({ resultsType, teamObj }) => {
  // This context comes from the GlobalContext Wrapper Component
  const appState = useContext(GlobalContext);
  const { user } = useAuth();

  const classes = useStyles();
  const [showPreview, setShowPreview] = useState(false);

  //New Team Photos
  const generateRandomSeed = () => {
    return Math.random().toString(36).substring(7);  // Generate a random string
};

// https://avatars.dicebear.com/api/jdenticon/28.svg?r=50&b=%2316ca97&w=100&h=100&quot;

let picture = teamObj.picture;
if (picture.includes("https://avatars.dicebear.com/api/jdenticon") || picture.includes("http://res.cloudinary.com/teammateme-com/image/upload/v1712259855/UserAvatar/x7kgrpnhq7vx5yze7krx.svg")) {
    const randomSeed = generateRandomSeed();  // Generate a random seed
    picture = `https://api.dicebear.com/9.x/icons/svg?seed=${randomSeed}`;  // Generate a random avatar
}

//   let picture = teamObj.picture;
//   if (
//     picture.includes("https://avatars.dicebear.com/api/jdenticon/") &&
//     picture.includes("svg?r=50&b=%2316ca97&w=100&h=100")
//   ) {
//     picture =
//       "https://res.cloudinary.com/teammateme/image/upload/v1701306221/UserAvatar/csy8csv1lwdahg0kwfql.png";
//   }


  const toggleTeamPreview = () => {
    setShowPreview(!showPreview);
  };

  const membershipsLength = teamObj.Memberships.length;

  const goToPublicTeamPage = () => {
    setTimeout(() => {
      NextRouter.push(`/publicteam/${teamObj.public_team_id}`);
    }, 2000);
  };

  const goToTeamPage = () => {
    // Move to public team page
    let status = false;
    teamObj.Memberships.forEach((membership) => {
      if (membership.memberId === user?.id) {
        status = true;
      }
    });
    if (status === true) {
      return NextRouter.push({
        pathname: `/team/${teamObj.public_team_id}`,
        query: { number: teamObj.id },
      });
    } else {
      return NextRouter.push(`/publicteam/${teamObj.public_team_id}`);
    }
  };

  return (
    <>
      {teamObj.type === "organization" && resultsType === "organizations" && (
        //some card
        <div style={{ width: "100%" }}>
          <Button
            style={{ overflow: "hidden", width: "100%" }}
            // onClick={goToTeamPage}
            onClick={goToPublicTeamPage}
          >
            <Grid container direction="column" style={{ width: "100%" }}>
              <Card className={classes.root} style={{ width: "100%" }}>
                <CardContent>
                  <div
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px  ",
                      overflow: "hidden",
                    }}
                  >
                    {teamObj?.type === "premium" && (
                      <>
                        <span className={classes.stickerStyle}>
                          <PremiumTeamSticker />
                        </span>
                      </>
                    )}
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px  ",
                      overflow: "hidden",
                    }}
                  >
                    {teamObj?.type === "organization" && (
                      <>
                        <span className={classes.stickerStyle}>
                          <OrganizationSticker />
                        </span>
                      </>
                    )}
                  </div>
                  <Grid container className={classes.cardMargin}>
                    <Grid container direction="row" justifyContent="center">
                      <Grid item xs={12} className={classes.avatarDiv}>
                        <Avatar
                          aria-label="team"
                          className={classes.avatar}
                          component="div"
                          src={picture}
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.cardHeader}>
                        <Typography variant="h5" className={classes.cardTitle}>
                          {teamObj.Team?.title || teamObj.title}
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        className={classes.cardFooter}
                      >
                        <div>
                          <Grid item xs={12}>
                            <Typography
                              className={classes.created}
                              component={"p"}
                            >
                              {"Created on "}
                              {moment(
                                teamObj.Team?.createdAt || teamObj.createdAt
                              ).format("MMMM Do, YYYY")}
                            </Typography>
                          </Grid>
                        </div>
                        <div>
                          <Grid item xs={12}>
                            <Typography className={classes.numberTeamMates}>
                              {(teamObj.Team?.Memberships?.length ||
                                membershipsLength) === 1
                                ? "1 member"
                                : (teamObj.Team?.Memberships?.length ||
                                    membershipsLength) + " members"}
                            </Typography>
                          </Grid>
                        </div>
                        <div>
                          <Grid item xs={12}>
                            <Typography
                              className={classes.numberTeamMates}
                            ></Typography>
                          </Grid>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Button>
        </div>
      )}
      {teamObj.type === "premium" && resultsType === "premium" && (
        <div style={{ width: "100%" }}>
          <Button
            style={{ overflow: "hidden", width: "100%" }}
            // onClick={goToTeamPage}
            onClick={goToPublicTeamPage}
            aria-label="team"
          >
            <Grid container direction="column" style={{ width: "100%" }}>
              <Card className={classes.root} style={{ width: "100%" }}>
                <CardContent>
                  <div
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px  ",
                      overflow: "hidden",
                    }}
                  >
                    {teamObj?.type === "premium" && (
                      <>
                        <span className={classes.stickerStyle}>
                          <PremiumTeamSticker />
                        </span>
                      </>
                    )}
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px  ",
                      overflow: "hidden",
                    }}
                  >
                    {teamObj?.type === "organization" && (
                      <>
                        <span className={classes.stickerStyle}>
                          <OrganizationSticker />
                        </span>
                      </>
                    )}
                  </div>
                  <Grid container className={classes.cardMargin}>
                    <Grid container direction="row" justifyContent="center">
                      <Grid item xs={12} className={classes.avatarDiv}>
                        <Avatar
                          aria-label="team"
                          className={classes.avatar}
                          component="div"
                          src={picture}
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.cardHeader}>
                        <Typography
                          variant="h5"
                          className={classes.cardTitle}
                          aria-label="team"
                        >
                          {teamObj.Team?.title || teamObj.title}
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        className={classes.cardFooter}
                      >
                        <div>
                          <Grid item xs={12}>
                            <Typography
                              className={classes.created}
                              component={"p"}
                            >
                              {"Created on "}
                              {moment(
                                teamObj.Team?.createdAt || teamObj.createdAt
                              ).format("MMMM Do, YYYY")}
                            </Typography>
                          </Grid>
                        </div>
                        <div>
                          <Grid item xs={12}>
                            <Typography className={classes.numberTeamMates}>
                              {(teamObj.Team?.Memberships?.length ||
                                membershipsLength) === 1
                                ? "1 member"
                                : (teamObj.Team?.Memberships?.length ||
                                    membershipsLength) + " members"}
                            </Typography>
                          </Grid>
                        </div>
                        <div>
                          <Grid item xs={12}>
                            <Typography
                              className={classes.numberTeamMates}
                            ></Typography>
                          </Grid>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Button>
        </div>
      )}

      {resultsType !== "organizations" &&
        resultsType !== "premium" &&
        teamObj.type === "basic" &&
        resultsType === "basic" && (
          <div style={{ width: "100%" }}>
            <Button
              style={{ overflow: "hidden", width: "100%" }}
              // onClick={goToTeamPage}
              onClick={goToPublicTeamPage}
              aria-label="team"
            >
              <Grid container direction="column" style={{ width: "100%" }}>
                <Card className={classes.root} style={{ width: "100%" }}>
                  <CardContent>
                    <div
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px  ",
                        overflow: "hidden",
                      }}
                    >
                      {teamObj?.type === "premium" && (
                        <>
                          <span className={classes.stickerStyle}>
                            <PremiumTeamSticker />
                          </span>
                        </>
                      )}
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px  ",
                        overflow: "hidden",
                      }}
                    >
                      {teamObj?.type === "organization" && (
                        <>
                          <span className={classes.stickerStyle}>
                            <OrganizationSticker />
                          </span>
                        </>
                      )}
                    </div>
                    <Grid container className={classes.cardMargin}>
                      <Grid container direction="row" justifyContent="center">
                        <Grid item xs={12} className={classes.avatarDiv}>
                          <Avatar
                            aria-label="team"
                            className={classes.avatar}
                            component="div"
                            src={picture}
                          />
                        </Grid>
                        <Grid item xs={12} className={classes.cardHeader}>
                          <Typography
                            variant="h5"
                            className={classes.cardTitle}
                          >
                            {teamObj.Team?.title || teamObj.title}
                          </Typography>
                        </Grid>
                        <Grid
                          container
                          direction="column"
                          justifyContent="center"
                          className={classes.cardFooter}
                        >
                          <div>
                            <Grid item xs={12}>
                              <Typography
                                className={classes.created}
                                component={"p"}
                              >
                                {"Created on "}
                                {moment(
                                  teamObj.Team?.createdAt || teamObj.createdAt
                                ).format("MMMM Do, YYYY")}
                              </Typography>
                            </Grid>
                          </div>
                          <div>
                            <Grid item xs={12}>
                              <Typography className={classes.numberTeamMates}>
                                {(teamObj.Team?.Memberships?.length ||
                                  teamObj.Memberships?.length) + " members"}
                              </Typography>
                            </Grid>
                          </div>
                          <div>
                            <Grid item xs={12}>
                              <Typography
                                className={classes.numberTeamMates}
                              ></Typography>
                            </Grid>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Button>
          </div>
        )}
    </>
  );
};

export default TeamCardItem;
